const contractsPopupTextAreaStyles = (lineCount = 2, height) => {
  const fontSize = 14;
  const verticalPadding = 4; // 2px top + 2px bottom
  const contentHeight = height - verticalPadding;
  const lineHeight = contentHeight / lineCount;
  return {
    fontSize: `${fontSize}px`,
    lineHeight: `${lineHeight}px`,
    height: `${height}px`,
    backgroundImage: `
      repeating-linear-gradient(
        to bottom,
        transparent,
        transparent ${lineHeight - 1}px,
        rgba(0, 0, 0, 0.3) ${lineHeight - 1}px,
        rgba(0, 0, 0, 0.3) ${lineHeight}px
      )
    `,
    backgroundSize: `100% ${lineHeight}px`,
    backgroundRepeat: 'repeat-y',
    backgroundPosition: 'left 1px',
    backgroundColor: '#ffffff',
    overflow: "hidden",
    resize: "vertical",
  };
}
export default contractsPopupTextAreaStyles
